import React, { forwardRef, useEffect, useState } from "react";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import classNames from "classnames";
import HttpService from "../../services/HttpService";
import { FeatureFlags, getFeatureFlag } from "../../utilities/featureFlags";

enum EvaluationTime {
    OnPipeline = "OnPipeline",
    Live = "Live",
}

export interface IFeatureFlagProps extends IEditableProps, IStyledProps {
    featureFlag: FeatureFlags;
    evaluationTime: EvaluationTime;
    children;
}

export default forwardRef((props: IFeatureFlagProps, ref: any) => {
    const { featureFlag, cmsId, className, editorClassObj, children, evaluationTime } = props;
    const isPipelineActive = getFeatureFlag(featureFlag);
    const evaluateOnPipeline = evaluationTime === EvaluationTime.OnPipeline;
    const [ enableFlag, setEnabledFlag ] = useState(evaluateOnPipeline && isPipelineActive);

    useEffect(() => {
        async function loadFeatureFlag() {
            const featureValue = true === (await HttpService.get<string>(`${process.env.GATSBY_API_URL}/feature-flag/${featureFlag}`, `feature-flag:${featureFlag}`));
            if (!featureValue) {
                console.warn(`Feature flag ${featureFlag} set to evaluate Live disabled`);
            }
            setEnabledFlag(featureValue);
        }
        if (featureFlag && evaluationTime === EvaluationTime.Live) {
            loadFeatureFlag();
        }
        if (evaluateOnPipeline && !isPipelineActive) {
            console.warn(`Feature flag ${featureFlag} set to evaluate on Pipeline disabled`);
        }
    }, [featureFlag]);

    return (
        <div data-id={cmsId} ref={ref} className={classNames(className, editorClassObj)}>
            {(enableFlag || !!cmsId) ? children : null}
        </div>
    );
});
